module.exports = __webpack_public_path__ + "img/11.5.COD.3f136fde.png";